module.exports = __webpack_public_path__ + "img/spins_6.704d8b3f.png";